import React, { useEffect, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { api, getImageUrl } from '../utils/api';
import { toast } from 'sonner';
import { Loader2, Newspaper } from 'lucide-react';

export default function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const data = await api.getArticles();
      setArticles(data);
    } catch (error) {
      toast.error('Failed to load articles');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout title="News & Articles">
        <div className="flex items-center justify-center py-20">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title="News & Articles">
      <div className="space-y-6" data-testid="articles-list">
        {articles.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center">
              <Newspaper className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No articles published yet</p>
            </CardContent>
          </Card>
        ) : (
          articles.map((article) => (
            <Card key={article.id} data-testid={`article-${article.id}`}>
              <CardHeader>
                {article.image_url && (
                  <img
                    src={getImageUrl(article.image_url)}
                    alt={article.title}
                    className="w-full h-48 object-cover rounded-lg mb-4"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <h3 className="text-2xl font-heading font-bold">{article.title}</h3>
                <p className="text-sm text-muted-foreground">
                  By {article.author} • {new Date(article.created_at).toLocaleDateString()}
                </p>
              </CardHeader>
              <CardContent>
                <div className="prose max-w-none text-foreground whitespace-pre-wrap">
                  {article.content}
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </DashboardLayout>
  );
}